import { Component, Input } from '@angular/core';
import { OnChanges, OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app.state';
import { NoteService } from '../note.service';
import { setOutlineIsActive, toggleOutlineIsCollapsed } from './outline.actions';

@Component({
  selector: 'nns-outline-item',
  host: {
    '[class]': 'classNames'
  },
  styles: [`
    .nns-outline-title{
      font-size: 12px;
      color: #1F1F1F;
      flex: 0 0 calc(100% - 16px);
      max-width: calc(100% - 16px);
      text-overflow: ellipsis;
      overflow: hidden;
      font-family: 'Roboto', sans-serif;
    }
    .nns-outline-title:hover, .nns-outline-title__active{
      color: #00A1B7;
    }
    .nns-outline-title__single{
      padding-left: 18px;
    }
    .nns-outline-children{
      padding-left: 8px;
      margin-top: 8px;
      flex: 0 0 100%;
      box-sizing: border-box;
    }
    .nns-outline-child__empty{
      padding-left: 16px;
    }
    .nns-outline-child:not(:last-child){
      margin-bottom: 8px;
    }
    .nns-outline-arrow{
      cursor: pointer;
      flex: 0 0 16px;
    }

    .nns-outline-arrow nns-icon{
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
    }
    .nns-outline-arrow{
      transform: rotate(90deg);
    }
    .nns-outline-arrow__collapsed{
      transform: rotate(180deg);
    }
    :host {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      box-sizing: border-box;
    }
    :host.nns-outline__main > .nns-outline-title{
      font-weight: 500;
    }
    :host.nns-outline__main .nns-outline-children{
      padding-left: 16px;
    }
  `, `
    :host-context(.nns-theme-night) .nns-outline-title{
      color: #fff;
    }
    :host-context(.nns-theme-night) .nns-outline-title:hover,
    :host-context(.nns-theme-night) .nns-outline-title__active{
      color: #00A1B7;
    }
  `],
  template: `
    <div class="nns-outline-arrow"
      *ngIf="item.children.length"
      [ngClass]="{'nns-outline-arrow__collapsed': item.isCollapsed}"
      (click)="onToggleItem()">
      <nns-icon icon="arrow-up"></nns-icon>
    </div>
    <a [href]="href"
      class="nns-outline-title"
      [ngClass]="{
                  'nns-outline-title__main': item.level === 0, 'nns-outline-title__single': item.level === 0 && !item.children.length,
                  'nns-outline-title__active': item.isActive
                  }"
      (click)="onOutlineClick($event, item.id)">
      {{item.text}}
    </a>
    <div class="nns-outline-children" *ngIf="item.children && item.children.length && item.isCollapsed">
      <div
        *ngFor="let child of item.children"
        class="nns-outline-child"
        [ngClass]="{'nns-outline-child__empty': !child.children || !child.children.length}">
        <nns-outline-item
          [item]="child"
          ></nns-outline-item>
      </div>
    </div>
  `
})
export class OutlineItemComponent implements OnChanges, OnInit {
  @Input() item;
  classNames: string;
  href;

  constructor(
    private noteService: NoteService,
    public _store: Store<IAppState>,
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(changes.item) {
      if(this.item.level === 0) {
        this.classNames = 'nns-outline__main';
      }
      const { origin, pathname } = window.location;
      this.href = `${origin}${pathname}#${this.item.id}`;
    }
  }

  onToggleItem() {
    this._store.dispatch(toggleOutlineIsCollapsed(this.item.id));
  }

  onOutlineClick(event, hash) {
    event.preventDefault();
    this.noteService.scrollToHash('#' + hash);
    const appElement = document.getElementsByTagName('nns-app')[0];
    this._store.dispatch(setOutlineIsActive(this.item.id, true));

    const element = document.getElementById(hash);
    this.postOutlineMessage(element)

    setTimeout(() => {
      appElement.addEventListener('scroll', scrollEventListener)
      const _this = this;
      function scrollEventListener() {
        _this._store.dispatch(setOutlineIsActive(_this.item.id, false));
        appElement.removeEventListener('scroll', scrollEventListener)
      }
    }, 50)
  }

  postOutlineMessage(element) {
    window.top.postMessage({
      message: 'editor:outline',
      value: {
        top: this.getElementOffsetPosition(element),
      }
    }, '*');
  }

  getElementOffsetPosition(element) {
    let offsetTop = 0;
    do {
      offsetTop  += element.offsetTop;
    } while (element = element.offsetParent);
    return offsetTop;
  }
}
